import React from "react";
import { node } from "prop-types";
import { Col, Container, Row } from "../Grid";
import Section from "../Section";

const Title = ({ children }) => {
	return <div className="section-try-for-free__title">{children}</div>;
};

Title.propTypes = {
	children: node.isRequired,
};

const Action = ({ children }) => {
	return <div className="section-try-for-free__action">{children}</div>;
};

Action.propTypes = {
	children: node.isRequired,
};

const SectionTryForFree = ({ children }) => {
	return (
		<Section className="section-try-for-free">
			<Container>
				<Row px>
					<Col utility={{ position: { position: "relative", zIndex: 1 } }}>{children}</Col>
				</Row>
			</Container>
		</Section>
	);
};

SectionTryForFree.propTypes = {
	children: node.isRequired,
};

SectionTryForFree.Title = Title;
SectionTryForFree.Action = Action;

export default SectionTryForFree;
